import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { throwError as observableThrowError } from 'rxjs';
import { Observable } from 'rxjs/Rx';
import { NotificationsService } from 'angular2-notifications';

@Injectable()
export class ModalInterceptor implements HttpInterceptor {

  constructor(private notificationsService: NotificationsService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req)
      .catch((httpError) => {
        // Intercepta o erro, mostra o toast com uma mensagem amigável e exibe no log o objeto completo do erro.
        let mensagemErro;
        if (httpError.error && httpError.error.mensagem) {
          mensagemErro = httpError.error.mensagem || httpError.error.humanMessage;
        } else if (httpError.error && httpError.error.humanMessage) {
          // tratamento paliativo para erros no login
          mensagemErro = httpError.error.humanMessage;
        } else {
          mensagemErro = 'Ocorreu um erro na sua solicitação';
        }
        this.notificationsService.error('Erro', mensagemErro);
        // Retorna o erro ao método que invocou a chamada
        return observableThrowError(httpError);
      }) as any;
  }
}
